import { useEffect, useMemo, useState } from 'react';
import { useCapsule } from './useContract';
import user from 'stores/user';
import useSend from './useSend';
import simpleDialog from 'stores/simpleDialog';
import usePreMining from './usePreMining';
import { getOnePieceServerApi } from 'gql-ops';

// let pollingStarted = false;

export default function useCapsuleMethods() {
    const capsule = useCapsule();
    const { hasPreMined } = usePreMining();
    const [tokenId, setTokenId] = useState<number>();
    const [nextTokenId, setNextTokenId] = useState<number>();
    const [capsuleMeta, setCapsuleMeta] = useState<any>();

    // async function getPermit() {
    //     try {
    //         const permit = (
    //             await getOnePieceServerApi().capsuleMintPermit({
    //                 address: user.address,
    //             })
    //         )?.capsuleMintPermit.permit;
    //         setCanMint(!!permit);
    //     } catch (e) {
    //         console.error('get permit error');
    //     }
    // }

    const send = useSend();

    async function getCapsuleInfo() {
        if (!capsule || !user.address) return;

        const tokenID = await capsule.ownerTokenId(user.address);
        const nextTokenId = await capsule.nextTokenId();
        setTokenId(Number(tokenID));
        setNextTokenId(Number(nextTokenId));
        if (tokenID) {
            try {
                const metadataBase64 = await capsule.tokenURI(tokenID);
                if (metadataBase64) {
                    const metadata = JSON.parse(atob(metadataBase64.split(',')[1]));
                    setCapsuleMeta(metadata);
                }
            } catch (error) {
                console.log(error);
            }
        }
    }

    async function mintCapsule() {
        if (!capsule || !user.address) return;
        let permit;
        try {
            permit = (
                await getOnePieceServerApi().capsuleMintPermit({
                    address: user.address,
                })
            )?.capsuleMintPermit.permit;
        } catch (e) {
            simpleDialog.error({
                title: 'Error',
                text: 'Get permit failed',
            });
        }

        if (!permit) {
            simpleDialog.error({
                title: 'Error',
                text: 'Empty permit, disabed minting',
            });
            return;
        }

        const p = JSON.parse(permit);
        console.log(p);
        await send({
            contract: capsule,
            method: 'mint',
            params: [user.address, hasPreMined, [p.permitType, p.nonce, p.dataHash, p.expire, p.sig]],
            pendingText: 'Minting capsule...',
            summary: `Minted capsule NFT`,
            showSuccess: false,
            async onSuccess() {
                await getCapsuleInfo();
                // await user.getUserInfo();
            },
        });
    }

    useEffect(() => {
        getCapsuleInfo();
    }, [capsule, user.address]);

    // useEffect(() => {
    //     let interval: any;
    //     let isWindowVisible = true;

    //     const handleVisibilityChange = () => {
    //         if (document.hidden) {
    //             isWindowVisible = false;
    //             clearInterval(interval);
    //             pollingStarted = false;
    //         } else {
    //             isWindowVisible = true;
    //             handlePermit();
    //         }
    //     };

    //     const handlePermit = () => {
    //         if (user.address && isWindowVisible && !pollingStarted) {
    //             pollingStarted = true;
    //             getPermit();
    //             interval = setInterval(() => {
    //                 getPermit();
    //             }, 6000);
    //         } else {
    //             setCanMint(false);
    //         }
    //     };

    //     handlePermit();

    //     document.addEventListener('visibilitychange', handleVisibilityChange);
    //     return () => {
    //         if (interval) {
    //             clearInterval(interval);
    //             pollingStarted = false;
    //         }
    //         document.removeEventListener('visibilitychange', handleVisibilityChange);
    //     };
    // }, [user.address]);

    return {
        tokenId,
        nextTokenId,
        isMinted: useMemo(() => {
            return tokenId && tokenId >= 1;
        }, [tokenId]),
        getCapsuleInfo,
        mintCapsule,
        capsuleMeta,
    };
}
